import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Btn from "./Btn";
import DialogCover from "./DialogCover";
import Dialog from "./Dialog";

const PostReportDialog = ({
  onCloseDialog,
  onReportReply,
  reportStatus,
  setReportStatus,
  post,
  nickName,
}) => {
  const { t } = useTranslation('navigation');
  const datas = [
    { id: 1, title: t('report.personal_info') },
    { id: 2, title: t('report.defamation') },
    { id: 3, title: t('report.commercial') },
    { id: 4, title: t('report.misinformation') },
    { id: 5, title: t('report.illegal') },
  ];
  const [reason, setReason] = useState("");
  const reportCard = (data) => {
    return (
      <>
        <input
          id={data.id}
          type="radio"
          name="blockReason"
          value={data.title}
          onChange={(e) => setReason(e.target.value)}
          className={"info"}
        />
        <label htmlFor={data.id} className="flex justify-between break-all">
          <span className="text-body3_500 text-black">{data.title}</span>
        </label>
      </>
    );
  };

  return (
    <>
      {reportStatus === "report" ? (
        <DialogCover
          onAction={onCloseDialog}
          innerClass={
            "z-90 bg-white rounded-md w-full mx-6 max-[320px]:max-h-[360px] overflow-y-scroll no-scrollbar  shadow-[0_0_12px_rgba(0,0,0,0.1)]"
          }
        >
          <div className="px-4 py-6">
            <h2 className="mb-6 text-subtitle2 text-black">{t('report.select_reason')}</h2>
            {datas.map((data) => (
              <div
                key={data.id}
                className={
                  "flex w-full items-center gap-2 rounded-md bg-gray_20 p-4 " +
                  (data.id === datas?.[datas.length - 1]?.id ? "" : "mb-3 ")
                }
              >
                {reportCard(data)}
              </div>
            ))}
          </div>
          <div className="m-4 flex items-center justify-between gap-2">
            <Btn
              innerClass={"w-fulll w-1/2"}
              bgColor={"bg-white"}
              textColor={"text-main"}
              borderColor={"border border-main"}
              title={t('report.cancel')}
              active={"on"}
              onAction={onCloseDialog}
            />
            <Btn
              innerClass={"w-fulll w-1/2"}
              bgColor={"bg-main"}
              textColor={"text-white"}
              borderColor={"border border-main"}
              title={t('report.report')}
              active={reason?.length > 0 ? "on" : "ready"}
              onAction={() => {
                onReportReply(reason);
                setReason("");
              }}
            />
          </div>
        </DialogCover>
      ) : reportStatus === "blocking" ? (
        <DialogCover
          onAction={onCloseDialog}
          innerClass={
            "z-50 bg-white rounded-md w-full mx-6 max-[320px]:max-h-[360px] overflow-y-scroll no-scrollbar  shadow-[0_0_12px_rgba(0,0,0,0.1)]"
          }
        >
          <div className="px-4 py-6">
            <h2 className="mb-4 text-subtitle2 text-black">
              {t('report.block_confirm')}
            </h2>
            <p className="text-body2_500l">
              {t('report.block_description', { name: nickName })}
            </p>
          </div>
          <div className="m-4 flex items-center justify-between gap-2">
            <Btn
              innerClass={"w-fulll w-1/2"}
              bgColor={"bg-main"}
              textColor={"text-white"}
              borderColor={"border border-main"}
              title={t('report.block')}
              active={"on"}
              onAction={() => {
                setReportStatus("block");
              }}
            />
            <Btn
              innerClass={"w-fulll w-1/2"}
              bgColor={"bg-white"}
              textColor={"text-main"}
              borderColor={"border border-main"}
              title={t('report.cancel')}
              active={"on"}
              onAction={onCloseDialog}
            />
          </div>
        </DialogCover>
      ) : reportStatus === "block" ? (
        <Dialog
          innerClass={"py-4 px-6 "}
          btnClass={"mt-8"}
          title={t('report.blocked_title')}
          desc={t('report.blocked_description', { name: nickName })}
          onRightBtnAction={onCloseDialog}
          onCoverAction={onCloseDialog}
        />
      ) : reportStatus === "complete" ? (
        <Dialog
          innerClass={"py-4 px-6"}
          btnClass={"mt-8"}
          title={t('report.report_complete_title', { type: post ? t('report.post') : t('report.comment') })}
          desc={t('report.report_complete_description', { type: post ? t('report.post') : t('report.comment') })}
          onRightBtnAction={onCloseDialog}
          onCoverAction={onCloseDialog}
        />
      ) : null}
    </>
  );
};

export default PostReportDialog;
